import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const CatalogReviewScreen = lazy(() => import('~/features/item-setup/pages/catalog-review-screen'));

export const Route = createFileRoute('/_authenticated/_tenant/item-setup/catalog-review')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <CatalogReviewScreen />
    </Suspense>
  ),
});
